{
  "fr": {
    "task_assignment": {
      "actions": {
        "confirm": "Marquer comme terminé",
        "create": "Tâche",
        "reopen": "Rouvrir",
        "update": "Modifier la tâche"
      },
      "assignee_types": {
        "customer": "Client",
        "employee": "Employé",
        "partner": "Partenaire"
      },
      "attributes": {
        "assignee": "Personne assignée",
        "assignees": "Personnes assignées",
        "created_at": "Créé",
        "due_date": "Échéance",
        "project": "Projet",
        "published": "Publié",
        "status": "Statut",
        "task": "Tâche",
        "unit": "Unité"
      },
      "labels": {
        "add_assignee": "Ajouter une personne assignée…",
        "add_customers": "Ajouter des clients",
        "already_assigned": "Cette tâche est déjà ajoutée à cette unité.",
        "completed": "Terminées",
        "confirm_message": "Voulez-vous vraiment marquer cette tâche comme terminée ?",
        "customers": "Clients",
        "my_tasks": "Mes tâches",
        "no_assignees": "Aucune personne assignée pour le moment.",
        "no_assignments": "Aucune tâche pour le moment.",
        "no_assignments_task": "Aucune assignation pour cette tâche pour le moment.",
        "no_assignments_unit": "Aucune tâche pour cette unité pour le moment.",
        "publish_all": "Tout publier",
        "publish_customers": "Publier pour les clients de chaque unité",
        "published": "Publié",
        "required": "Ce champ est obligatoire",
        "select_task": "Sélectionner une tâche",
        "upload_hint": "Téléversez le ou les documents demandés pour terminer cette tâche.",
        "uploaded_documents": "Documents téléversés"
      },
      "statuses": {
        "completed": "Terminé",
        "draft": "Brouillon",
        "pending": "En attente"
      },
      "toasts": {
        "completed": "Tâche terminée",
        "create": "Tâche créée",
        "delete": "Tâche supprimée",
        "uncompleted": "Tâche rouverte",
        "update": "Tâche mise à jour"
      }
    }
  }
}
